import { useEffect, useState } from "react";
import brain from "./images/braingif.gif";
import eggimg from "./images/egg_static.gif";
import body from "./images/bodynew.gif";
import dick from "./images/dick.gif";
import foot from "./images/footgif.gif";
import egg1 from "./images/eggMove.gif";
import egg2 from "./images/eggStationary.gif";
let i = 0;

function Continue() {
  const [egg, setEgg] = useState(false);
  const [step, setStep] = useState(0);
  const [eggImg, setEggImg] = useState(egg1);

  let textArray = [
    "When you will have made him a body without organs...",
    "then you will have delivered him from all his automatic reactions...",
    "and restored him to his true freedom...",
  ];

  const [text, setText] = useState(textArray[i]);
  const [showCredits, setShowCredits] = useState(false);

  function nextText() {
    i = i + 1;
    setStep(i);
    setText(textArray[i]);
    console.log(i);
  }

  const eggTime = () => {
    if (step === 7) {
      setTimeout(() => {
        setEggImg(egg2);
        setTimeout(() => {
          setShowCredits(true);
        }, 200);
      }, 6300);
    }
  };

  useEffect(() => {
    eggTime();
  }, [step]);

  return (
    <div className="App">
      {step <= 2 && (
        <div className="contDiv">
          <p>{text}</p>
          <br />

          <button onClick={() => nextText()}>Continue</button>
        </div>
      )}
      {step === 3 && (
        <div className="contDiv2">
          <img src={body} className="egg" />

          <button onClick={() => nextText()}>Continue</button>
        </div>
      )}
      {step === 4 && (
        <div className="contDiv">
          <p> it is crisscrossed with axes </p>
          <img src={brain} />
          <p>and thresholds, with latitudes and longitudes </p>
          <button onClick={() => nextText()}>Continue</button>
        </div>
      )}
      {step === 5 && (
        <div className="contDiv">
          <p> traversed by gradients </p>
          <img src={dick} />
          <p>marking the transitions and the becomings</p>
          <button onClick={() => nextText()}>Continue</button>
        </div>
      )}
      {step === 6 && (
        <div className="contDiv">
          <p>
            {" "}
            the destinations of the subject developing along these particular
            vectors{" "}
          </p>
          <img src={foot} />
          <p>
            Nothing here is representative; rather, it is all life and lived
            experience…
          </p>
          <button onClick={() => nextText()}>Continue</button>
        </div>
      )}
      {step === 7 && (
        <div className="contDiv">
          <img src={eggImg} />
          {}
          {showCredits && (
            <div>
              {" "}
              <p>Text from Gilles Deleuze's Anti-Oedipus</p>
              <p> Music by Austin Scott</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Continue;
